import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Link } from "react-router-dom";

const values = [
  { icon: "ri-movie-2-line", title: "海量影视", desc: "汇聚电影、电视剧与综艺三大频道，内容丰富多样。" },
  { icon: "ri-hd-line", title: "高清画质", desc: "坚持高清内容呈现，带来清晰舒适的视觉体验。" },
  { icon: "ri-filter-3-line", title: "便捷筛选", desc: "支持地区、年份、类型多维筛选与排序，快速定位。" },
  { icon: "ri-shield-star-line", title: "正版理念", desc: "倡导正版内容理念，尊重每一位创作者的劳动成果。" },
];

export default function About() {
  usePageMeta(
    "关于我们 - 91在线视频",
    "了解91在线视频平台：聚焦高清影视内容在线播放，提供电影、电视剧及综艺节目的展示与浏览服务，坚持正版、高清与丰富类别的理念。",
  );

  return (
    <div className="mx-auto w-full max-w-screen-2xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <section className="mt-4 overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
        <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr]">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-3 py-1 text-xs text-accent-500">
              <i className="ri-play-fill" />
              关于 91在线视频
            </span>
            <h1 className="mt-4 font-heading text-2xl font-700 text-foreground-950 md:text-3xl">
              聚焦高清影视的在线视频平台
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              91在线视频是一家聚焦高清影视内容在线播放的平台，目标用户涵盖喜欢在线电影、
              最新电视剧及热门综艺节目的观众群体。我们围绕“内容展示”与“便捷筛选”打造平台，
              突出正版、高清和丰富类别，帮助用户快速寻找感兴趣的作品、了解作品信息，
              并获得舒适流畅的浏览体验。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              本站为前端演示站点，不涉及会员付费、下载或真实播放接口，所有影视信息均为示例内容，
              仅用于展示平台的分类、筛选、搜索与浏览功能。
            </p>
          </div>
          <div className="relative h-48 w-full md:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20cinema%20screening%20room%20with%20rows%20of%20comfortable%20seats%20and%20a%20large%20glowing%20screen%20in%20deep%20blue%20ambient%20lighting%20with%20warm%20orange%20accent%20glow%20cinematic%20highly%20detailed%20photography%20atmosphere&width=1200&height=900&seq=about-hero-01&orientation=landscape"
              alt="91在线视频平台"
              title="91在线视频 - 高清影视视频在线播放平台"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent md:bg-gradient-to-r md:from-background-100 md:to-transparent" />
          </div>
        </div>
      </section>

      <section className="mt-10">
        <h2 className="font-heading text-xl font-600 text-foreground-950 md:text-2xl">
          我们坚持的理念
        </h2>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200/70 bg-background-100 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-accent-500">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-3 font-heading text-base font-600 text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div className="rounded-lg border border-background-200/70 bg-background-100 p-6">
          <div className="mb-3 flex items-center gap-2">
            <i className="ri-copyright-line text-accent-500" />
            <h2 className="font-heading text-lg font-600 text-foreground-950">版权声明</h2>
          </div>
          <p className="text-sm leading-relaxed text-foreground-600">
            本站所有影视信息、图片及文字内容均为演示示例，仅用于产品功能展示，不构成任何真实内容服务。
            若涉及第三方素材版权，请相关权利人联系我们，我们将及时处理。本站尊重并遵守相关法律法规，
            倡导正版影视内容。
          </p>
        </div>
        <div className="rounded-lg border border-background-200/70 bg-background-100 p-6">
          <div className="mb-3 flex items-center gap-2">
            <i className="ri-error-warning-line text-accent-500" />
            <h2 className="font-heading text-lg font-600 text-foreground-950">免责声明</h2>
          </div>
          <p className="text-sm leading-relaxed text-foreground-600">
            本项目为前端演示站点，不提供视频播放、下载、会员付费及注册登录等功能。
            页面上展示的影视资料、评分、播放量等数据均为虚拟内容，仅供参考展示，
            不对其真实性作出任何承诺，也不承担由此产生的任何责任。
          </p>
        </div>
      </section>

      <section className="mt-10 rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-8">
        <div className="mb-3 flex items-center gap-2">
          <i className="ri-feedback-line text-accent-500" />
          <h2 className="font-heading text-lg font-600 text-foreground-950">反馈与联系</h2>
        </div>
        <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
          如果您对平台的功能、分类或内容展示有任何建议，欢迎通过以下方式与我们取得联系。
          本页面仅提供联系方式说明，暂未开放在线提交入口。
        </p>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {[
            { icon: "ri-mail-line", label: "意见反馈邮箱", value: "feedback@91video-demo.cn" },
            { icon: "ri-customer-service-2-line", label: "客服在线时间", value: "周一至周五 09:00 - 18:00" },
            { icon: "ri-map-pin-line", label: "平台所在地", value: "中国 · 北京" },
          ].map((item) => (
            <div key={item.label} className="flex items-start gap-3 rounded-lg bg-background-50 p-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-accent-500">
                <i className={`${item.icon} text-lg`} />
              </span>
              <div className="min-w-0">
                <p className="text-xs text-foreground-500">{item.label}</p>
                <p className="mt-0.5 break-words text-sm font-600 text-foreground-900">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/category/movie"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-600 text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-compass-3-line" />
            浏览影视分类
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
        </div>
      </section>
    </div>
  );
}